let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8YFnR")).then(() => parcelRequire('5ACVQ'));